onDomLoad(($dom) => {
  $dom
    .find("[data-behaviour='copy-reconciliation-data-modal']")
    .each((index, el) => {
      el.addEventListener('click', () => {
        const modalParams = {
          currentPeriodName: el.dataset.periodName,
          reconciliationTextName: el.dataset.reconciliationTextName,
          ledgerId: el.dataset.ledgerId,
          reconciliationTextId: el.dataset.reconciliationTextId,
        }

        window.modalCitizen.openModal(
          'copy-reconciliation-data-modal',
          modalParams
        )
      })
    })
})
